module.exports = __webpack_public_path__ + "img/call.d4f58bc.png";